// Source: app/scripts/controllers/navigation.js
Auction.controller('NavigationController', [
  '$scope',
  '$location',
  '$window',
  '$route',
  'Auth',
  'Nav',
  '$rootScope',
  'ProductSubcategories',
  '$cookieStore',
  function ($scope, $location, $window, $route, Auth, Nav, $rootScope, ProductSubcategories, $cookieStore) {
    $scope.openLanguageMenu = false;
    $scope.openUserMenu = false;
    var navExpanded = 268;
    var navCollapsed = 110;
    $scope.navWidth = 268;
    $scope.collapse = true;
    $scope.containerStyle = {
      'min-height': '358px',
      'margin-left': navExpanded + 'px'
    };

    $scope.navStyle = {
      'width': navExpanded + 'px'
    };

    function collapse() {
      $scope.containerStyle['margin-left'] = navCollapsed + 'px';
      $scope.navStyle['width'] = navCollapsed + 'px';
      $scope.collapse = false;
    }

    function expand() {
      $scope.containerStyle['margin-left'] = navExpanded + 'px';
      $scope.navStyle['width'] = navExpanded + 'px';
      $scope.collapse = true;
    }

    angular.element($window).bind('resize', function () {
      $scope.onResizeFunction();
      $scope.$apply();
    });

    $scope.onResizeFunction = function () {
      if ($window.innerWidth < 768) {
        collapse();
        $scope.smallWindow = true;
      } else {
        expand();
        $scope.smallWindow = false;
      }
    };
    $scope.collapseMenu = function () {
      if ($scope.smallWindow) return;
      if ($scope.collapse) {
        collapse();
      } else {
        expand();
      }
    }

    $scope.onResizeFunction();

    $scope.expandMenu = function (url) {
      var page = $scope.pages[url],
        group;

      if (page) {
        group = page.group;
        while (group) {
          $scope.expands[group.id] = true;
          group = group.parent;
        }
      }
    };

    $scope.isActive = function (viewLocation) {
      var re = new RegExp(viewLocation),
        active = re.test($location.path());
      if (active) {
        $scope.expandMenu(viewLocation);
      }
      return active;
    };

    $scope.logout = function () {
      Auth.logout();
    };

    $scope.expands = {};
    $scope.pages = {};

    Nav.registerCallback(function (nav) {
      angular.forEach(nav.pages, function (page) {
        $scope.pages[page.url] = page;
      });
    });

    $scope.goToEcounterSysytem = function(){
      $rootScope.sytem = 'E_COUNTER';
      $cookieStore.put('systemToken', 'E_COUNTER');

      Nav.newFetch($rootScope.sytem);
      $rootScope.showOption = 2;


    };

    $scope.goToEauctionSysytem = function(){

      $rootScope.sytem = 'E_AUCTION';
      $cookieStore.put('systemToken', 'E_AUCTION');
      if($rootScope.user){
        Nav.newFetch($rootScope.sytem);
      }else{
        ProductSubcategories.categoryNavigation();
      }

      $rootScope.showOption = 1;
    };

    $scope.goToGeneralSystem = function(){
      $rootScope.sytem = 'GENERAL';
      Nav.newFetch($rootScope.sytem);

      $rootScope.showOption = 0;
    };




  }
]);
